import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CarList1 from "../../assets/images/carlist-1.jpg";
import CarList2 from "../../assets/images/carlist-2.jpg";
import CarList3 from "../../assets/images/carlist-3.jpg";
import CarList4 from "../../assets/images/carlist-4.jpg";
import CarList5 from "../../assets/images/carlist-5.jpg";
import CarList6 from "../../assets/images/carlist-6.jpg";
import CarList7 from "../../assets/images/carlist-7.jpg";
import CarList8 from "../../assets/images/carlist-8.jpg";
import CarList9 from "../../assets/images/carlist-9.jpg";
import { IoReturnDownForward } from "react-icons/io5";

const cars = {
  Economy: [{ name: "Economy", image: CarList1, value: "Economy" }],
  Electric: [{ name: "Electric", image: CarList2, value: "Electric" }],
  Standard: [{ name: "Standard", image: CarList3, value: "Standard" }],
  Cabrio: [{ name: "Cabrio", image: CarList4, value: "Cabrio" }],
  JeepSUV: [{ name: "Jeep/SUV", image: CarList5, value: "Jeep-SUV-Family" }],
  SpecialLuxury: [{ name: "Special", image: CarList6, value: "Special" }],
  MiniVans: [{ name: "Mini Vans", image: CarList7, value: "Mini Vans" }],
  Motorbikes: [{ name: "Motorbikes", image: CarList8, value: "Motorbikes" }],
  ATVQuads: [{ name: "ATV-Quads", image: CarList9, value: "ATV-Quads" }],
};

const CarList = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/search', {
      state: {
        selectedCategory: [category.value],
        pickupDate: null,
        dropoffDate: null
      }
    });
  };

  return (
    <section className="w-full">
      <motion.div 
        className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mt-6 px-4 lg:px-8 max-w-[1440px] mx-auto transition-all"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ 
          duration: 0.5,
          staggerChildren: 0.2
        }}
      >
        {Object.values(cars)
          .flat()
          .map((car) => (
            <motion.div 
              key={car.name} 
              className="w-full cursor-pointer"
              onClick={() => handleCategoryClick(car)}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{ y: -10 }}
            >
              <motion.div 
                className="relative w-full h-[300px] lg:h-[400px] overflow-hidden flex rounded-lg p-[2px] bg-gradient-to-r from-gray-300 via-gray-500 to-gray-300 shadow-xl bg-gray-200"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <motion.div 
                  className="absolute inset-0 bg-black rounded-lg opacity-25 z-10"
                  whileHover={{ opacity: 0.5 }}
                  transition={{ duration: 0.3 }}
                />
                <div className="group relative z-10">
                   <motion.div
                    initial={{ x: -20, opacity: 0 }}
                    whileHover={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <IoReturnDownForward className="absolute left-6 bottom-[107px] text-white text-3xl group-hover:ml-4 ease-in-out duration-300" />
                 </motion.div>
                  <h3 
                    className="absolute left-14 bottom-24 text-white text-2xl p-2 tracking-wide Aleo group-hover:ml-4 ease-in-out duration-300"
                    
                  >
                    {car.name}
                  </h3>
                </div>
                <motion.hr 
                  className="absolute left-6 bottom-[93px] w-12 border-2 border-gray-400 h-0.5 z-50"
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                />
                <h3 className="absolute left-4 bottom-12 text-gray-300 font-thin text-md p-2 tracking-normal italic select-none z-50">
                  MYKONOS BEST RATES
                </h3>
                <motion.img
                  src={car.image}
                  alt={car.name}
                  className="object-cover h-full w-full rounded-lg"
                  initial={{ scale: 1.1 }}
                  whileHover={{ scale: 1.15 }}
                  transition={{ duration: 0.5 }}
                />
              </motion.div>
            </motion.div>
          ))}
      </motion.div>
    </section>
  );
};

export default CarList;
